import type { MarketingLocale } from './guides';

// Versioned files are deployed separately from the application bundle.
export const VIDEO_ORIGIN = 'https://mindstream-product-media.srmayecheng.workers.dev';
const content = {
  en: {
    title: 'From a product brief to your next buyer conversation.',
    description: 'A 48-second Buyer Radar demo: find relevant companies, check the evidence, prepare outreach and follow company signals.',
    watch: 'Watch the 48-second demo', play: 'Play the 48-second demo', loading: 'Loading video…',
    note: 'Product captured October 28, 2026. Act shows 12 sample contacts; Monitor uses a historical example. No narration; music only.',
    transcript: 'Read the video walkthrough', open: 'Open the video', error: 'The video could not play. Try the player controls or open it directly.',
    steps: [
      ['00:00', 'Find the opportunity', 'Start with what you sell and the market you want to explore.'],
      ['00:03', 'Set the direction', 'The example brief is pharmacy automation, Thailand, and local distributors or integrators.'],
      ['00:08', 'Discover a relevant company', 'Buyer Radar surfaces UB Thailand, with evidence you can inspect.'],
      ['00:12', 'Check why it fits', 'Its product page lists medicine counting and packaging systems, Thai healthcare customers and a CRETEM distribution line. This supports business fit; buying interest is not confirmed.'],
      ['00:23', 'Make the first message relevant', 'A separate outreach example for Abstract Computers connects its hospital systems and pharmacy integration work with the seller’s automation offering. You review and refine the draft.'],
      ['00:28', 'Track contacts in one place', 'Twelve fictional sample contacts illustrate batch preparation and individual progress. You review and send in Gmail; the worklist tracks contact status. These are demonstration records, not campaign results.'],
      ['00:36', 'Monitor a company in context', 'With VT healthcare selected, the feed shows that company’s historical signals and original sources, including automated dispensing already operating at SIS Hospital.'],
      ['00:44', 'Try it with your product', 'Discover, Act and Monitor help you find an opportunity and follow it through.'],
    ],
  },
  'zh-Hans': {
    title: '从产品需求，到下一次客户对话。',
    description: '48 秒了解 Buyer Radar：发现匹配公司，核对依据，准备开发信，并持续跟踪公司的动态。',
    watch: '48 秒了解 Buyer Radar', play: '播放 48 秒产品演示', loading: '正在加载视频…',
    note: '产品录制于 2026 年 10 月 28 日。Act 使用 12 条演示联系人；Monitor 为历史案例。视频仅含配乐，无旁白。',
    transcript: '阅读视频流程说明', open: '直接打开视频', error: '视频暂时无法播放，请尝试播放器控件或直接打开视频。',
    steps: [
      ['00:00', '发现机会', '从你销售的产品和想探索的市场开始。'],
      ['00:03', '明确方向', '示例需求是药房自动化设备、泰国市场，以及当地经销商或系统集成商。'],
      ['00:08', '发现匹配公司', 'Buyer Radar 找到 UB Thailand，并提供可查看的依据。'],
      ['00:12', '核对为什么匹配', '其官网列出了药品计数与包装系统、泰国医疗客户，以及 CRETEM 经销产品线。这些支持业务匹配，尚未确认采购意向。'],
      ['00:23', '让开场白更有针对性', '另一个开发信示例围绕 Abstract Computers 的医院系统与药房集成业务，介绍卖方的自动化设备。你可以审核和修改草稿。'],
      ['00:28', '系统跟进每个联系人', '12 条虚构演示联系人展示批量准备和逐条进度。你在 Gmail 审核、发送，工作台跟踪联系状态；这些并非真实营销成效。'],
      ['00:36', '围绕一家公司持续观察', '选中 VT healthcare 后，查看其历史信号及原始来源，包括已在 SIS Hospital 运行的自动发药系统。'],
      ['00:44', '用你的产品试一试', '通过 Discover、Act 和 Monitor，发现机会并持续跟进。'],
    ],
  },
  'zh-Hant': {
    title: '從產品需求，到下一次客戶對話。',
    description: '48 秒了解 Buyer Radar：發現匹配公司，核對依據，準備開發信，並持續跟蹤公司的動態。',
    watch: '48 秒了解 Buyer Radar', play: '播放 48 秒產品演示', loading: '正在載入影片…',
    note: '產品錄製於 2026 年 10 月 28 日。影片為簡體中文；Act 使用 12 條演示聯絡人，Monitor 為歷史案例。僅含配樂，無旁白。',
    transcript: '閱讀影片流程說明', open: '直接開啟影片', error: '影片暫時無法播放，請嘗試播放器控制項或直接開啟影片。',
    steps: [
      ['00:00', '發現機會', '從你銷售的產品和想探索的市場開始。'],
      ['00:03', '明確方向', '示例需求是藥房自動化設備、泰國市場，以及當地經銷商或系統整合商。'],
      ['00:08', '發現匹配公司', 'Buyer Radar 找到 UB Thailand，並提供可查看的依據。'],
      ['00:12', '核對為甚麼匹配', '其官網列出了藥品計數與包裝系統、泰國醫療客戶，以及 CRETEM 經銷產品線。這些支持業務匹配，尚未確認採購意向。'],
      ['00:23', '讓開場白更有針對性', '另一個開發信示例圍繞 Abstract Computers 的醫院系統與藥房整合業務，介紹賣方的自動化設備。你可以審核和修改草稿。'],
      ['00:28', '系統跟進每個聯絡人', '12 條虛構演示聯絡人展示批量準備和逐條進度。你在 Gmail 審核、發送，工作台跟蹤聯絡狀態；這些並非真實行銷成效。'],
      ['00:36', '圍繞一家公司持續觀察', '選中 VT healthcare 後，查看其歷史信號及原始來源，包括已在 SIS Hospital 運行的自動發藥系統。'],
      ['00:44', '用你的產品試一試', '透過 Discover、Act 和 Monitor，發現機會並持續跟進。'],
    ],
  },
};

export function productVideo(locale: MarketingLocale) {
  const language = locale === 'en' ? 'en' : 'zh-Hans';
  const id = `buyer-radar-${locale === 'en' ? 'en' : 'zh'}-20261030`;
  return { ...content[locale], language, id, src: `${VIDEO_ORIGIN}/${id}.mp4`, poster: `${VIDEO_ORIGIN}/${id}.webp` };
}

export function videoStructuredData(locale: MarketingLocale, pageUrl: string) {
  const video = productVideo(locale);
  return {
    '@context': 'https://schema.org', '@type': 'VideoObject', name: video.title,
    description: video.description, thumbnailUrl: video.poster, contentUrl: video.src,
    uploadDate: '2026-10-30T00:00:00+08:00', duration: 'PT48S', inLanguage: video.language,
    mainEntityOfPage: pageUrl, publisher: { '@type': 'Organization', name: 'Mindstream', url: 'https://mindstreamapp.ai/' },
  };
}
